import styled from 'styled-components';
import { pixelProps } from '@styles/utils';

type SkewImageSeparatorWraperProps = {
  height: number;
  margin: number;
};

export const SkewImageSeparatorWraper = styled.div`
  ${pixelProps<SkewImageSeparatorWraperProps>('height')}
  margin-top: ${(props: SkewImageSeparatorWraperProps) => props.margin}px;
  margin-bottom: ${(props: SkewImageSeparatorWraperProps) => props.margin}px;
`;

type ImageContainerProps = {
  height: number;
  angle: number;
};

export const ImageContainer = styled.div`
  ${pixelProps<ImageContainerProps>('height')}
  transform: skewY(${(props: ImageContainerProps) => (props.angle)}deg);
  overflow: hidden;
  position: relative;
`;

type ImageProps = {
  image: string;
  angle: number;
  translate?: number;
};

export const Image = styled.div`
  background-image: url('${(props: ImageProps) => props.image}');
  background-position: center center;
  background-size: 100% auto;
  transform:
    skewY(-${(props: ImageProps) => (props.angle)}deg)
    translateY(${(props: ImageProps) => (props.translate || 0)}px)
  ;
  position: absolute;
  background-repeat: no-repeat;
  left: 0;
  right: 0;
  top: -50%;
  bottom: -50%;
`;


// WEBPACK FOOTER //
// src/app/src/components/SkewImageSeparator/SkewImageSeparator.s.ts